import React from "react";
import "../index.css"; // If using global styles

const Popup = ({ isOpen, closePopup, imageSrc, text }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black bg-opacity-60"
        onClick={closePopup}
      ></div>

      {/* Popup Container */}
      <div className="relative z-10 bg-white w-full max-w-3xl mx-auto rounded-lg overflow-hidden shadow-2xl animate-pop-in flex flex-col md:flex-row max-h-[90vh]">
        
        {/* Image Side */}
        {imageSrc && (
          <div className="w-full md:w-1/2">
            <img
              src={imageSrc}
              alt="Popup"
              className="w-full h-auto object-cover md:h-full rounded-t-lg md:rounded-t-none md:rounded-l-lg"
            />
          </div>
        )}

        {/* Content Side */}
        <div className="relative p-5 md:p-6 w-full md:w-1/2 bg-white flex flex-col justify-center items-start text-left overflow-y-auto">
          {/* Close Button */}
          <button
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-800 text-2xl md:text-xl"
            onClick={closePopup}
            aria-label="Close"
          >
            &times;
          </button>

          {/* Header */}
          <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-2 text-center w-full">
            Στη μνήμη του παππού μου
          </h2>

          {/* Message */}
          <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-4 text-center md:text-left">
            {text ||
              "Η παρούσα ιστοσελίδα δημιουργήθηκε με σκοπό να τιμήσω τη μνήμη του πολυαγαπημένου μου παππού †Πρωτοπρεσβύτερο Βασίλειο Τσιούνη."}
          </p>

          {/* Button */}
          <div className="w-full flex justify-center md:justify-start">
            <button
              className="px-5 py-2 bg-black text-white text-sm font-medium rounded hover:bg-gray-800 transition"
              onClick={closePopup}
            >
              Συνέχεια στην ιστοσελίδα
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
